<section>
    <div class="mainDiv">
      <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/pluce_img.png" class="pluce_icon_content" alt="">
        <div class="banner_content">
            <h1 class="whiteTitle">{{headerTitle}}</h1>
            <div class="subMenu_content">
                <app-sub-menu></app-sub-menu>
            </div>
            
        </div>
        <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/yellow_fish_color.png" class="fish_img_content" alt="">
     <div class="top_header">
      <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/blog-top-bg-header.png" width="100%" alt="">
      <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/girl_img.png" class="girl_img_content" alt="">
     </div>
     <div class="search_content">
      <div class="form-group">
      </div>
  </div>
<div class="blog_content">
  <div class="all_blog mt-5" *ngIf="allBlogs">    
    <app-all-blog></app-all-blog>

  </div>
  <div class="blog_imgGallery mt-5" *ngIf="!allBlogs">
    <app-blog-details></app-blog-details>
  </div>
</div>
<!-- <div class="sub_content">
  <div class="container-fluid custom-nav">
    <div class="row align-items-center">
      <div class="col-auto">
        <a href="#" class="logo">Legacy</a>
      </div>
      <div class="col-auto d-flex nav-tabs-custom">
        <a href="#" class="active">Legacy</a>
        <a href="#">Kidzee Advantage</a>
        <a href="#">Vision & Mission</a>
        <a href="#">Awards & Recognition</a>
      </div>

      <div class="col-auto d-flex align-items-center arrow-controls justify-content-end">
         <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/icon/leftarrow.png" width="20%" alt="">
        <div class="divider"></div>
        <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/icon/rightarrow.png" width="20%" alt="">
      </div>
 <div class="col d-flex justify-content-end align-items-center flex-wrap gap-3 mt-2 mt-md-0">
        <div class="search-box">
          <input type="text" placeholder="Search">
          <i class="fas fa-search"></i>
        </div>
        <div class="social-icons">
          <a href="#"><img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/icon/facebook.png" width="13%" alt=""></a>
          <a href="#"><img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/icon/Instagram.png" width="13%" alt=""></a>
          <a href="#"><img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/icon/youtube.png" width="13%" alt=""></a>
        </div>
      </div>
    </div>
  </div>

   <div class="container py-4">
    <div class="row g-4">
      <div class="col-lg-4">
        <div class="blog-card">
          <div class="blog_img_card">
          <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/blog_img.png" alt="Blog Image" />
        </div>
          <div class="blog-content_bg">
            <h5>5 Reasons Why Kindergarten Franchise in India is on the Boom</h5>
            <p class="text-muted">
              Discover the transformative growth of kindergarten franchises in India, driven by a surge in demand for quality early childhood education. Explore how these franchises redefine early education through innovative approaches, enriching experiences, and holistic development initiatives.
            </p>
            <div class="d-flex justify-content-between align-items-center mt-3">
              <div class="author-info">
                <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/blog_sub_img.png" width="100%" alt="Author" />
                <div>
                  <strong>Name</strong><br/>
                  <small>May 27, 2025</small>
                </div>
              </div>
              <button class="read-more">Read More</button>
            </div>
          </div>
        </div>
      </div>
   <div class="col-lg-5">
        <div class="row">
           <div class="col-12">
            <div class="d-flex blog-card">
              <div class="card_sm_img">
              <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/blog_img.png" alt="Small Blog" />
             </div>
              <div class="blog-content flex-grow-1">
                <h6 class="mb-1 text-truncate">5 Tips to Ease Your Child's Transition</h6>
                <p class="mb-2 small text-muted">Learn five important strategies to help your child settle into preschool curriculum with ease. Get professional advice to </p>
                <div class="d-flex justify-content-between align-items-center">
                  <div class="author-info">
                    <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/blog_sub_img.png" width="100%" alt="Author" />
                    <div>
                      <strong>Name</strong><br/>
                      <small>May 27, 2025</small>
                    </div>
                  </div>
                  <button class="read-more">Read More</button>
                </div>
              </div>
            </div>
          </div>
           <div class="col-12">
            <div class="d-flex blog-card">
              <div class="card_sm_img">
              <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/blog_img.png" alt="Small Blog" />
             </div>
              <div class="blog-content flex-grow-1">
                <h6 class="mb-1 text-truncate">5 Tips to Ease Your Child's Transition</h6>
                <p class="mb-2 small text-muted">Learn five important strategies to help your child settle into preschool curriculum with ease. Get professional advice to </p>
                <div class="d-flex justify-content-between align-items-center">
                  <div class="author-info">
                    <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/blog_sub_img.png" width="100%" alt="Author" />
                    <div>
                      <strong>Name</strong><br/>
                      <small>May 27, 2025</small>
                    </div>
                  </div>
                  <button class="read-more">Read More</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-3">
        <h5 class="most-popular-title mb-3">Most Popular</h5>
    <div class="col-12">
            <div class="d-flex blog-card">
              <div class="card_sm_img">
              <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/blog_img.png" alt="Small Blog" />
             </div>
              <div class="blog-content-right flex-grow-1">
                <h6 class="mb-1 text-truncate">5 Tips to Ease Your Child's Transition</h6>
                <p class="mb-2 small text-muted">Learn five important strategies to help your child settle into preschool curriculum with ease. Get professional advice to </p>
                <div class="d-flex justify-content-between align-items-center">
                  <div class="author-info">
                    <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/blog_sub_img.png" width="100%" alt="Author" />
                    <div>
                      <strong>Name</strong><br/>
                      <small>May 27, 2025</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>

  <div class="container-fluid custom-nav">
    <div class="row align-items-center">
      <div class="col-4">
        <a href="#" class="logo">Legacy</a>
      </div>
      <div class="col-4 d-flex align-items-center arrow-controls justify-content-end">
         <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/icon/leftarrow.png" width="8%" alt="">
        <div class="divider"></div>
        <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/icon/rightarrow.png" width="8%" alt="">
      </div>
    </div>
  </div>

  <div class="container py-4">
    <div class="row g-4">
      <div class="col-lg-4">
        <div class="blog-card">
          <div class="blog_img_card">
          <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/blog_img.png" alt="Blog Image" />
        </div>
          <div class="blog-content_bg">
            <h5>5 Reasons Why Kindergarten Franchise in India is on the Boom</h5>
            <p class="text-muted">
              Discover the transformative growth of kindergarten franchises in India, driven by a surge in demand for quality early childhood education. Explore how these franchises redefine early education through innovative approaches, enriching experiences, and holistic development initiatives.
            </p>
            <div class="d-flex justify-content-between align-items-center mt-3">
              <div class="author-info">
                <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/blog_sub_img.png" width="100%" alt="Author" />
                <div>
                  <strong>Name</strong><br/>
                  <small>May 27, 2025</small>
                </div>
              </div>
              <button class="read-more">Read More</button>
            </div>
          </div>
        </div>
      </div>
   <div class="col-lg-5">
        <div class="row">
           <div class="col-12">
            <div class="d-flex blog-card">
              <div class="card_sm_img">
              <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/blog_img.png" alt="Small Blog" />
             </div>
              <div class="blog-content flex-grow-1">
                <h6 class="mb-1 text-truncate">5 Tips to Ease Your Child's Transition</h6>
                <p class="mb-2 small text-muted">Learn five important strategies to help your child settle into preschool curriculum with ease. Get professional advice to </p>
                <div class="d-flex justify-content-between align-items-center">
                  <div class="author-info">
                    <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/blog_sub_img.png" width="100%" alt="Author" />
                    <div>
                      <strong>Name</strong><br/>
                      <small>May 27, 2025</small>
                    </div>
                  </div>
                  <button class="read-more">Read More</button>
                </div>
              </div>
            </div>
          </div>
           <div class="col-12">
            <div class="d-flex blog-card">
              <div class="card_sm_img">
              <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/blog_img.png" alt="Small Blog" />
             </div>
              <div class="blog-content flex-grow-1">
                <h6 class="mb-1 text-truncate">5 Tips to Ease Your Child's Transition</h6>
                <p class="mb-2 small text-muted">Learn five important strategies to help your child settle into preschool curriculum with ease. Get professional advice to </p>
                <div class="d-flex justify-content-between align-items-center">
                  <div class="author-info">
                    <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/blog_sub_img.png" width="100%" alt="Author" />
                    <div>
                      <strong>Name</strong><br/>
                      <small>May 27, 2025</small>
                    </div>
                  </div>
                  <button class="read-more">Read More</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-3">
        <div class="admission-card text-center">
    <h4 class="text-left">Admission</h4>
    <form>
      <div class="mb-2 text-start">
        <input type="text" class="form-control" placeholder="Name" required>
      </div>
      <div class="mb-2 text-start">
        <input type="email" class="form-control" placeholder="Email" required>
      </div>
      <div class="mb-2 text-start">
        <input type="tel" class="form-control" placeholder="Mobile" required>
      </div>
      <div class="mb-3 text-start">
        <input type="text" class="form-control" placeholder="Pin Code" required>
      </div>
      <button type="submit" class="btn btn-submit">Submit</button>
    </form>
  </div>
      </div>
    </div>
  </div>
    </div> -->
    </div>
</section>

